<app-page class="bill" [notFound]="notFound" [showPageProgressBar]="!(bill$ | async) || !loaded" [showPageClosure]="true">
    <div header *ngIf="!(billsIsUnavailable$ | async) && !loadError">
        <h1 *ngIf="!(parcel$ | async)">
            <egov-text-ui-placeholder> Account T000000-00000000000 </egov-text-ui-placeholder>
        </h1>
        <h1 *ngIf="parcel$ | async">
            Account
            <span class="inline-block">{{ accountNumber$ | async }}</span>
        </h1>
    </div>

    <div toolbarLeft class="toolbar-title">
        <egov-text-ui-placeholder *ngIf="!(bill$ | async)">Tax Year 0000</egov-text-ui-placeholder>
        <ng-container *ngIf="bill$ | async" ngPreserveWhitespaces>
            Tax Year {{ (bill$ | async)!.taxYear }}
            <em *ngIf="(bill$ | async)?.isPreliminary" class="preliminary-installment">Installment Only</em>
        </ng-container>
    </div>

    <ppt-bill-actions toolbarRight class="option-buttons page-wide-options" color="white" [billId]="id$ | async"></ppt-bill-actions>

    <ng-container pageContent>
        <ng-container *ngIf="!(billsIsUnavailable$ | async)">
            <ng-container *ngIf="!loadError">
                <egov-message *ngIf="delegatedMessage$ | async as message" type="error" [class.has-link]="!!(delegateLink$ | async)">
                    <div [innerHtml]="message | MarkdownToHtml"></div>
                    <p *ngIf="delegateLink$ | async as link">
                        <a [href]="link" target="_blank">{{ delegateLinkText$ | async }}</a>
                    </p>
                </egov-message>
                <ppt-parcel-history
                    [taxYear]="taxYear$ | async"
                    [accountNumber]="accountNumber$ | async"
                    [historyPrintUrl]="(bill$ | async)?.historyPrintUrl"
                    [loaded]="!!(bill$ | async)"
                ></ppt-parcel-history>
                <ppt-parcel-details [bill]="bill$ | async" [parcel]="parcel$ | async"></ppt-parcel-details>

                <div
                    class="bill-content"
                    *ngIf="
                        !(bill$ | async) ||
                        !(bill$ | async)?.satisfiesBillPage ||
                        (hasAnyChargesWhatsoever$ | async) ||
                        (!(bill$ | async)?.payments?.length && (bill$ | async)?.projections?.length) ||
                        (bill$ | async)?.certificate ||
                        (state$ | async) === 'tn'
                    "
                >
                    <!-- Define projections template -->

                    <ng-template #projections>
                        <div
                            class="content-block projections"
                            *ngIf="!(bill$ | async) || (!(bill$ | async)?.payments?.length && (bill$ | async)?.projections?.length)"
                        >
                            <h2 class="line">Bill Projections</h2>
                            <div class="content-pane bill-projections">
                                <table class="styled frameless">
                                    <thead>
                                        <tr>
                                            <th>
                                                <div class="content">If Paid By</div>
                                            </th>
                                            <th class="numeric">
                                                <div class="content">Amount</div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            *ngFor="
                                                let projection of ((bill$ | async)?.projections?.length && (bill$ | async)?.projections) || nullLists.get(6)
                                            "
                                        >
                                            <td>
                                                <ng-container *ngIf="projection">
                                                    {{ projection.date | date }}
                                                </ng-container>
                                                <egov-text-ui-placeholder *ngIf="!projection" length="12"></egov-text-ui-placeholder>
                                            </td>
                                            <td class="numeric">
                                                <ng-container *ngIf="projection">
                                                    {{ projection.amount }}
                                                </ng-container>
                                                <egov-text-ui-placeholder *ngIf="!projection"> $000.00 </egov-text-ui-placeholder>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ng-template>

                    <!-- Content for Florida -->

                    <div class="columns" *ngIf="(state$ | async) === 'fl'">
                        <div class="content-block charges">
                            <h2 class="line">{{ taxYear$ | async }} Charges</h2>
                            <app-show-more class="content-pane no-padding" [disabled]="!(viewport.tablet$ | async)">
                                <div class="ad-valorem" *ngIf="!(bill$ | async)?.charges || (bill$ | async)?.charges?.adValorem?.charges?.length">
                                    <h3 class="broken-down-only line">Ad-Valorem Taxes</h3>
                                    <table class="styled frameless">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div class="content">
                                                        <h3>Ad-Valorem Taxes</h3>
                                                    </div>
                                                </th>
                                                <th class="numeric">
                                                    <div class="content">Assessed</div>
                                                </th>
                                                <th class="numeric">
                                                    <div class="content">Exempt</div>
                                                </th>
                                                <th class="numeric">
                                                    <div class="content">Taxable</div>
                                                </th>
                                                <th class="numeric">
                                                    <div class="content">Millage</div>
                                                </th>
                                                <th class="numeric">
                                                    <div class="content">Amount</div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let charge of (bill$ | async)?.charges?.adValorem.charges || nullLists.get(9)">
                                                <td class="authority">
                                                    <div class="flex">
                                                        <span class="name">
                                                            <ng-container *ngIf="charge">
                                                                {{ charge.description }}
                                                            </ng-container>
                                                            <egov-text-ui-placeholder
                                                                *ngIf="!charge"
                                                                length="21"
                                                                lengthThreshold="6"
                                                            ></egov-text-ui-placeholder>
                                                        </span>
                                                        <span class="phone">
                                                            <ng-container *ngIf="charge">
                                                                {{ charge.phone | USPhone }}
                                                            </ng-container>
                                                            <egov-text-ui-placeholder
                                                                *ngIf="!charge"
                                                                length="16"
                                                                lengthThreshold="0"
                                                            ></egov-text-ui-placeholder>
                                                        </span>
                                                    </div>
                                                </td>
                                                <td class="numeric" data-label="Assessed">
                                                    <ng-container *ngIf="charge">{{ charge.assessed }}</ng-container>
                                                    <egov-text-ui-placeholder *ngIf="!charge" length="7" lengthThreshold="0"></egov-text-ui-placeholder>
                                                </td>
                                                <td class="numeric" data-label="Exempt">
                                                    <ng-container *ngIf="charge">{{ charge.exempt }}</ng-container>
                                                    <egov-text-ui-placeholder *ngIf="!charge" length="7" lengthThreshold="0"></egov-text-ui-placeholder>
                                                </td>
                                                <td class="numeric" data-label="Taxable">
                                                    <ng-container *ngIf="charge">{{ charge.taxable }}</ng-container>
                                                    <egov-text-ui-placeholder *ngIf="!charge" length="7" lengthThreshold="0"></egov-text-ui-placeholder>
                                                </td>
                                                <td class="millage numeric" data-label="Millage">
                                                    <ng-container *ngIf="charge">{{ charge.millage }}</ng-container>
                                                    <egov-text-ui-placeholder *ngIf="!charge" length="7" lengthThreshold="0"></egov-text-ui-placeholder>
                                                </td>
                                                <td class="amount numeric">
                                                    <ng-container *ngIf="charge">
                                                        {{ charge.amount | currency }}
                                                    </ng-container>
                                                    <egov-text-ui-placeholder *ngIf="!charge" length="7" lengthThreshold="0"></egov-text-ui-placeholder>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colspan="6">
                                                    <div class="flex">
                                                        <span class="label">Ad-Valorem Total</span>
                                                        <span class="value">
                                                            <ng-container *ngIf="(bill$ | async)?.charges">
                                                                {{ (bill$ | async)?.charges?.adValorem.total | currency }}
                                                            </ng-container>
                                                            <egov-text-ui-placeholder *ngIf="!(bill$ | async)?.charges" length="8"></egov-text-ui-placeholder>
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <div class="non-ad-valorem" *ngIf="!(bill$ | async)?.charges || (bill$ | async)?.charges?.nonAdValorem?.charges?.length">
                                    <table class="styled frameless">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div class="content">
                                                        <h3>Non Ad-Valorem Assessments</h3>
                                                    </div>
                                                </th>
                                                <th class="numeric">
                                                    <div class="content">Amount</div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let charge of (bill$ | async)?.charges?.nonAdValorem?.charges || nullLists.get(5)">
                                                <td>
                                                    <ng-container *ngIf="charge">{{ charge.description }}</ng-container>
                                                    <egov-text-ui-placeholder *ngIf="!charge" length="30" lengthThreshold="6"></egov-text-ui-placeholder>
                                                </td>
                                                <td class="numeric">
                                                    <ng-container *ngIf="charge">
                                                        {{ charge.amount | currency }}
                                                    </ng-container>
                                                    <egov-text-ui-placeholder *ngIf="!charge" length="7"></egov-text-ui-placeholder>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colspan="2">
                                                    <div class="flex">
                                                        <span class="label">Non Ad-Valorem Total</span>
                                                        <span class="value">
                                                            <ng-container *ngIf="(bill$ | async)?.charges">
                                                                {{ (bill$ | async)?.charges?.nonAdValorem?.total | currency }}
                                                            </ng-container>
                                                            <egov-text-ui-placeholder *ngIf="!(bill$ | async)?.charges" length="8"></egov-text-ui-placeholder>
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <div class="fee-interest" *ngIf="!(bill$ | async)?.charges || (bill$ | async)?.charges?.feesAndInterests?.charges?.length">
                                    <table class="styled frameless">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div class="content">
                                                        <h3>Fees & Interest</h3>
                                                    </div>
                                                </th>
                                                <th class="numeric">
                                                    <div class="content">Amount</div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let charge of (bill$ | async)?.charges?.feesAndInterests?.charges || nullLists.get(2)">
                                                <td>
                                                    <ng-container *ngIf="charge">{{ charge.description }}</ng-container>
                                                    <egov-text-ui-placeholder *ngIf="!charge" length="30" lengthThreshold="6"></egov-text-ui-placeholder>
                                                </td>
                                                <td class="numeric">
                                                    <ng-container *ngIf="charge">
                                                        {{ charge.amount | currency }}
                                                    </ng-container>
                                                    <egov-text-ui-placeholder *ngIf="!charge" length="7"></egov-text-ui-placeholder>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colspan="2">
                                                    <div class="flex">
                                                        <span class="label">Fees & Interests Total</span>
                                                        <span class="value">
                                                            <ng-container *ngIf="(bill$ | async)?.charges?.feesAndInterests">
                                                                {{ (bill$ | async)?.charges?.feesAndInterests?.total | currency }}
                                                            </ng-container>
                                                            <egov-text-ui-placeholder
                                                                *ngIf="!(bill$ | async)?.charges?.feesAndInterests"
                                                                length="8"
                                                            ></egov-text-ui-placeholder>
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <div class="total flex">
                                    <span class="label">Total Certified Combined</span>
                                    <span class="value">
                                        <ng-container *ngIf="(bill$ | async)?.charges">{{ (bill$ | async)?.amount | currency }}</ng-container>
                                        <egov-text-ui-placeholder *ngIf="!(bill$ | async)?.charges" length="7"></egov-text-ui-placeholder>
                                    </span>
                                </div>
                            </app-show-more>
                        </div>
                        <aside
                            *ngIf="
                                !(bill$ | async) ||
                                !(bill$ | async)?.satisfiesBillPage ||
                                (!(bill$ | async)?.payments?.length && (bill$ | async)?.projections?.length) ||
                                (bill$ | async)?.certificate
                            "
                        >
                            <ng-container *ngTemplateOutlet="projections"></ng-container>
                            <div
                                class="content-block certificate"
                                *ngIf="!(bill$ | async) || !(bill$ | async)?.satisfiesBillPage || (bill$ | async)?.certificate"
                            >
                                <h2 class="line">
                                    Bill Certificate
                                    <span class="certificate-id">
                                        <ng-container *ngIf="(bill$ | async)?.certificate?.info">
                                            {{ (bill$ | async)!.certificate!.info!.year }}-{{ (bill$ | async)!.certificate!.info!.number }}
                                        </ng-container>
                                        <egov-text-ui-placeholder *ngIf="!(bill$ | async)?.certificate?.info" length="11"></egov-text-ui-placeholder>
                                    </span>
                                </h2>
                                <div class="blocks">
                                    <div
                                        class="holder-block"
                                        *ngIf="!(bill$ | async) || !(bill$ | async)?.satisfiesBillPage || (bill$ | async)?.certificate?.holder"
                                    >
                                        <h3 class="line">Holder</h3>
                                        <div class="content-pane holder">
                                            <p *ngIf="!(bill$ | async) || !(bill$ | async)?.satisfiesBillPage || (bill$ | async)?.certificate?.holder?.name">
                                                <strong *ngIf="(bill$ | async)?.certificate?.holder">
                                                    {{ (bill$ | async)?.certificate?.holder.name }}
                                                </strong>
                                                <egov-text-ui-placeholder *ngIf="!(bill$ | async)?.certificate?.holder" length="35"></egov-text-ui-placeholder>
                                            </p>
                                            <p *ngIf="!(bill$ | async) || !(bill$ | async)?.satisfiesBillPage || (certificateHasAddress$ | async)">
                                                <ng-container *ngIf="(bill$ | async)?.certificate?.holder">
                                                    <ng-container *ngIf="(bill$ | async)!.certificate!.holder.address1">
                                                        {{ (bill$ | async)!.certificate!.holder.address1 }}
                                                        <br />
                                                    </ng-container>
                                                    <ng-container *ngIf="(bill$ | async)!.certificate!.holder.address2">
                                                        {{ (bill$ | async)!.certificate!.holder.address2 }}
                                                        <br />
                                                    </ng-container>
                                                    <ng-container *ngIf="(bill$ | async)!.certificate!.holder.city">
                                                        {{ (bill$ | async)!.certificate!.holder.city }},
                                                    </ng-container>
                                                    <ng-container *ngIf="(bill$ | async)!.certificate!.holder.state">
                                                        {{ (bill$ | async)!.certificate!.holder.state }}
                                                    </ng-container>
                                                    <ng-container *ngIf="(bill$ | async)!.certificate!.holder.zip">
                                                        {{ (bill$ | async)!.certificate!.holder.zip }}
                                                    </ng-container>
                                                </ng-container>
                                                <ng-container *ngIf="!(bill$ | async)?.certificate?.holder">
                                                    <egov-text-ui-placeholder length="28"></egov-text-ui-placeholder>
                                                    <br />
                                                    <egov-text-ui-placeholder length="24"></egov-text-ui-placeholder>
                                                </ng-container>
                                            </p>
                                            <!-- Email / Contact temporarily hidden -->
                                            <!--ng-container *ngIf="!(bill$ | async) || (bill$ | async)?.certificate?.holder.contact">
                                                <p *ngIf="(bill$ | async)?.certificate && (bill$ | async)!.certificate!.holder.contact != 'relay'">
                                                    <a href="mailto:{{ asCertificateHolderContactInfo((bill$ | async)!.certificate!.holder.contact!).email }}">
                                                        {{ asCertificateHolderContactInfo((bill$ | async)!.certificate!.holder.contact!).email }}
                                                    </a>
                                                </p>
                                                <p *ngIf="!(bill$ | async) || (bill$ | async)?.certificate?.holder.contact == 'relay'">
                                                    <a href="#" (click)="showContactBidderDialog($event)">
                                                        <ng-container *ngIf="(bill$ | async)?.certificate?.holder">
                                                            <mat-icon>email</mat-icon>
                                                            Contact Bidder
                                                        </ng-container>
                                                        <egov-text-ui-placeholder *ngIf="!(bill$ | async)?.certificate?.holder" length="20"></egov-text-ui-placeholder>
                                                    </a>
                                                </p>
                                            </ng-container-->
                                        </div>
                                    </div>
                                    <div
                                        class="certificate-info-block"
                                        *ngIf="!(bill$ | async) || !(bill$ | async)?.satisfiesBillPage || (bill$ | async)?.certificate?.info"
                                    >
                                        <h3 class="line">Certificate</h3>
                                        <div class="content-pane content-block certificate-info">
                                            <table>
                                                <tr>
                                                    <td>Year</td>
                                                    <td>
                                                        <ng-container *ngIf="(bill$ | async)?.certificate?.info">
                                                            {{ (bill$ | async)!.certificate!.info.year }}
                                                        </ng-container>
                                                        <egov-text-ui-placeholder *ngIf="!(bill$ | async)?.certificate?.info"> 0000 </egov-text-ui-placeholder>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Number</td>
                                                    <td>
                                                        <ng-container *ngIf="(bill$ | async)?.certificate?.info">
                                                            {{ (bill$ | async)!.certificate!.info.number }}
                                                        </ng-container>
                                                        <egov-text-ui-placeholder *ngIf="!(bill$ | async)?.certificate?.info"> 000 </egov-text-ui-placeholder>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Sold</td>
                                                    <td>
                                                        <ng-container *ngIf="(bill$ | async)?.certificate?.info">
                                                            {{ (bill$ | async)!.certificate!.info.sold | date }}
                                                        </ng-container>
                                                        <egov-text-ui-placeholder
                                                            *ngIf="!(bill$ | async)?.certificate?.info"
                                                            length="10"
                                                        ></egov-text-ui-placeholder>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Bid Percentage</td>
                                                    <td>
                                                        <ng-container *ngIf="(bill$ | async)?.certificate?.info">
                                                            {{ (bill$ | async)!.certificate!.info.bidPercentage }} %
                                                        </ng-container>
                                                        <egov-text-ui-placeholder
                                                            *ngIf="!(bill$ | async)?.certificate?.info"
                                                            length="4"
                                                        ></egov-text-ui-placeholder>
                                                    </td>
                                                </tr>

                                                <!-- Items temporarily hidden -->
                                                <!--tr>
                                                    <td>Face</td>
                                                    <td>
                                                        <ng-container *ngIf="(bill$ | async)?.certificate?.info">{{ (bill$ | async)!.certificate!.info.face | currency }}</ng-container>
                                                        <egov-text-ui-placeholder *ngIf="!(bill$ | async)?.certificate?.info" length="7"></egov-text-ui-placeholder>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Interest</td>
                                                    <td>
                                                        <ng-container *ngIf="(bill$ | async)?.certificate?.info">{{ (bill$ | async)!.certificate!.info.interest | currency }}</ng-container>
                                                        <egov-text-ui-placeholder *ngIf="!(bill$ | async)?.certificate?.info" length="6"></egov-text-ui-placeholder>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>T/C Fee</td>
                                                    <td>
                                                        <ng-container *ngIf="(bill$ | async)?.certificate?.info">{{ (bill$ | async)!.certificate!.info.tcFee | currency }}</ng-container>
                                                        <egov-text-ui-placeholder *ngIf="!(bill$ | async)?.certificate?.info" length="4"></egov-text-ui-placeholder>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Total</td>
                                                    <td>
                                                        <ng-container *ngIf="(bill$ | async)?.certificate?.info">{{ (bill$ | async)!.certificate!.info.total | currency }}</ng-container>
                                                        <egov-text-ui-placeholder *ngIf="!(bill$ | async)?.certificate?.info" length="7"></egov-text-ui-placeholder>
                                                    </td>
                                                </tr-->
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </aside>
                    </div>

                    <!-- Content for Tennesse -->

                    <ng-container *ngIf="false && (state$ | async) === 'tn'">
                        <div class="content-block">
                            <h2 class="line">
                                <ng-container *ngIf="taxYear$ | async; else billInfoTitlePlaceholder"> {{ taxYear$ | async }} Bill Information </ng-container>
                                <ng-template #billInfoTitlePlaceholder>
                                    <egov-text-line-ui-placeholder>0000 Bill Information</egov-text-line-ui-placeholder>
                                </ng-template>
                            </h2>
                            <div class="content-pane no-padding bill-info">
                                <section class="margin">
                                    <div class="table-container"></div>
                                    <footer>&nbsp;</footer>
                                </section>
                                <ng-container *ngIf="(appraisalInfo$ | async) !== undefined && (taxInfo$ | async) !== undefined; else billInfoPlaceholders">
                                    <section class="appraisal" *ngIf="showAppraisalInfo$ | async">
                                        <div class="table-container">
                                            <table class="styled borderless">
                                                <tbody>
                                                    <tr *ngFor="let item of appraisalItems$ | async; let i = index">
                                                        <td>{{ item.name }}</td>
                                                        <td class="numeric">
                                                            <span class="operator" *ngIf="i > 0"><mat-icon>add</mat-icon></span>
                                                            {{ item.amount | currency }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <footer>
                                            <div class="label">{{ (appraisalInfo$ | async)?.yearAppraised }} Appraisal</div>
                                            <div class="value">{{ (appraisalInfo$ | async)?.totalPropertyValue | currency }}</div>
                                        </footer>
                                    </section>
                                    <section class="taxable" *ngIf="showTaxable$ | async">
                                        <app-data-connector *ngIf="showAppraisalInfo$ | async"></app-data-connector>
                                        <div class="table-container">
                                            <table class="styled borderless">
                                                <tbody>
                                                    <tr *ngIf="(viewport.width$ | async)! > 1100 || (showAppraisalInfo$ | async) !== true">
                                                        <td>Appraised</td>
                                                        <td class="numeric">
                                                            <ng-container *ngIf="(taxInfo$ | async)?.totalPropertyValue !== null; else appraisedNa">
                                                                {{ (taxInfo$ | async)?.totalPropertyValue | currency }}
                                                            </ng-container>
                                                            <ng-template #appraisedNa><app-na></app-na></ng-template>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Taxable Rate</td>
                                                        <td class="numeric">
                                                            <ng-container *ngIf="(taxInfo$ | async)?.assessmentPercentage !== null; else taxableRateNa">
                                                                <span class="operator"><mat-icon>close</mat-icon></span>
                                                                {{ (taxInfo$ | async)?.assessmentPercentage }} %
                                                            </ng-container>
                                                            <ng-template #taxableRateNa><app-na></app-na></ng-template>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <footer>
                                            <div class="label">Taxable</div>
                                            <div class="value">
                                                {{ (taxInfo$ | async)?.assessedValue | currency }}
                                            </div>
                                        </footer>
                                    </section>
                                    <section class="levy" *ngIf="showTaxLevy$ | async">
                                        <app-data-connector *ngIf="showTaxable$ | async"></app-data-connector>
                                        <div class="table-container">
                                            <table class="styled borderless">
                                                <tbody>
                                                    <tr *ngIf="(viewport.width$ | async)! > 1100 || (showTaxable$ | async) !== true">
                                                        <td>Taxable</td>
                                                        <td class="numeric">
                                                            <ng-container *ngIf="(taxInfo$ | async)?.assessedValue !== null; else taxableNa">
                                                                {{ (taxInfo$ | async)?.assessedValue | currency }}
                                                            </ng-container>
                                                            <ng-template #taxableNa><app-na></app-na></ng-template>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{ (bill$ | async)?.taxYear }} Tax Rate</td>
                                                        <td class="numeric">
                                                            <ng-container *ngIf="(taxInfo$ | async)?.taxRate !== null; else taxRateNa">
                                                                <span class="operator"><mat-icon>close</mat-icon></span>
                                                                {{ (taxInfo$ | async)?.taxRate }} %
                                                            </ng-container>
                                                            <ng-template #taxRateNa><app-na></app-na></ng-template>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <footer>
                                            <div class="label">Tax Levy</div>
                                            <div class="value">
                                                {{ (taxInfo$ | async)?.taxLevy | currency }}
                                            </div>
                                        </footer>
                                    </section>

                                    <!-- Hidden until data is being served properly -->
                                    <section class="balance" *ngIf="false">
                                        <app-data-connector *ngIf="showTaxLevy$ | async"></app-data-connector>
                                        <div class="table-container" *ngIf="(viewport.width$ | async)! > 1100 || (balanceMovements$ | async)?.length">
                                            <table class="styled borderless">
                                                <tbody>
                                                    <tr *ngIf="(viewport.width$ | async)! > 1100 || (showTaxLevy$ | async) !== true">
                                                        <td>Tax Levy</td>
                                                        <td class="numeric">
                                                            <ng-container *ngIf="(taxInfo$ | async)?.taxLevy !== null; else taxLevyNa">
                                                                {{ (taxInfo$ | async)?.taxLevy | currency }}
                                                            </ng-container>
                                                            <ng-template #taxLevyNa><app-na></app-na></ng-template>
                                                        </td>
                                                    </tr>
                                                    <tr *ngFor="let movement of balanceMovements$ | async">
                                                        <td>{{ movement.name }}</td>
                                                        <td class="numeric">
                                                            <span class="operator">
                                                                <mat-icon>{{ movement.positive ? "add" : "remove" }}</mat-icon>
                                                            </span>
                                                            {{ movement.amount | currency }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <footer>
                                            <div class="label">Balance</div>
                                            <div class="value">{{ (taxInfo$ | async)!.billBalance | currency }}</div>
                                        </footer>
                                    </section>
                                </ng-container>
                                <ng-template #billInfoPlaceholders>
                                    <ng-template #billInfoColumnPlaceholder let-showDataConnector="showDataConnector">
                                        <section class="placeholder">
                                            <app-data-connector *ngIf="showDataConnector"></app-data-connector>
                                            <div class="table-container">
                                                <table class="styled borderless">
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <egov-text-ui-placeholder [length]="10" [lengthThreshold]="10"></egov-text-ui-placeholder>
                                                            </td>
                                                            <td class="numeric">
                                                                <egov-text-ui-placeholder [length]="5" [lengthThreshold]="2"></egov-text-ui-placeholder>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <egov-text-ui-placeholder [length]="10" [lengthThreshold]="10"></egov-text-ui-placeholder>
                                                            </td>
                                                            <td class="numeric">
                                                                <egov-text-ui-placeholder [length]="5" [lengthThreshold]="2"></egov-text-ui-placeholder>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <footer>
                                                <div class="label">
                                                    <egov-text-ui-placeholder length="20" lengthThreshold="1"></egov-text-ui-placeholder>
                                                </div>
                                                <div class="value">
                                                    <egov-text-ui-placeholder length="5" lengthThreshold="2"></egov-text-ui-placeholder>
                                                </div>
                                            </footer>
                                        </section>
                                    </ng-template>
                                    <ng-container *ngTemplateOutlet="billInfoColumnPlaceholder; context: { showDataConnector: false }"></ng-container>
                                    <ng-container *ngTemplateOutlet="billInfoColumnPlaceholder; context: { showDataConnector: true }"></ng-container>
                                    <ng-container *ngTemplateOutlet="billInfoColumnPlaceholder; context: { showDataConnector: true }"></ng-container>
                                    <ng-container *ngTemplateOutlet="billInfoColumnPlaceholder; context: { showDataConnector: true }"></ng-container>
                                </ng-template>
                                <section class="margin">
                                    <div class="table-container"></div>
                                    <footer>&nbsp;</footer>
                                </section>
                            </div>
                        </div>
                        <ng-container *ngTemplateOutlet="projections"></ng-container>
                    </ng-container>
                </div>
            </ng-container>
            <app-content-placeholder
                *ngIf="loadError"
                type="error"
                [showRetry]="loadErrorRetry"
                (retry)="retry()"
                customMessage="Error retrieving bill information."
            ></app-content-placeholder>
        </ng-container>

        <div class="content-placeholder-message unavailable" *ngIf="billsIsUnavailable$ | async">
            <mat-icon>block</mat-icon>
            <div class="text">
                <p>We are currently unable to display bills.</p>
                <p>Please, try again later.</p>
            </div>
        </div>
    </ng-container>

    <app-data-disclaimer afterContent [disclaimers]="disclaimers$ | async"></app-data-disclaimer>
</app-page>
